import { assertUserIdentity, CoreEventFactory } from '@segment/analytics-core';
import { createMessageId } from '../lib/get-message-id';
export class NodeEventFactory extends CoreEventFactory {
    constructor() {
        super({
            createMessageId,
            onFinishedEvent: (event) => {
                assertUserIdentity(event);
            },
        });
    }
}
//# sourceMappingURL=event-factory.js.map